import React from "react";
import { useTranslation } from "react-i18next";

const SavedCreditCard = ({ savedPaymentMethod, onDeletePaymentMethod }) => {
  const { t } = useTranslation();

  // Render card icon based on brand
  const renderCardIcon = (brand) => {
    switch (brand?.toLowerCase()) {
      case "visa":
        return <span data-testid="card-brand">💳 Visa</span>;
      case "mastercard":
        return <span data-testid="card-brand">💳 Mastercard</span>;
      case "amex":
        return <span data-testid="card-brand">💳 Amex</span>;
      case "discover":
        return <span data-testid="card-brand">💳 Discover</span>;
      default:
        return <span data-testid="card-brand">💳 Card</span>;
    }
  };

  const cardNumber = savedPaymentMethod.last4 || savedPaymentMethod.card?.last4 || "****";
  const expMonth = savedPaymentMethod.exp_month || savedPaymentMethod.card?.exp_month;
  const expYear = savedPaymentMethod.exp_year || savedPaymentMethod.card?.exp_year;

  return (
    <ul className="divide-y divide-gray-200" data-testid="saved-credit-card">
      <li key={savedPaymentMethod.id} className="py-1">
        <div className="flex justify-between items-center">
          <div className="flex items-center cursor-pointer">
            <span className="mr-2">
              {renderCardIcon(
                savedPaymentMethod.brand || savedPaymentMethod.card?.brand
              )}
            </span>
            <div data-testid="card-details">
              <span data-testid="card-number">•••• {cardNumber}</span>
              {expMonth && expYear && (
                <span
                  className="text-black-light text-sm ml-2"
                  data-testid="card-expiry"
                >
                  {t("payment_methods.expires_on")} {expMonth}/
                  {expYear.toString().slice(-2)}
                </span>
              )}
            </div>
          </div>
          <div className="flex space-x-2">
            <button
              type="button"
              onClick={() => onDeletePaymentMethod(savedPaymentMethod.id)}
              className="text-red-600 hover:text-red-800"
              aria-label="Delete payment method"
              data-testid="delete-button"
            >
              <svg
                className="h-5 w-5"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                />
              </svg>
            </button>
          </div>
        </div>
      </li>
    </ul>
  );
};

export default SavedCreditCard;
